import React, {useState, useEffect} from 'react'; // useEffect

import TextField from '@mui/material/TextField';

import {useFormStore} from '../../../Stores/form';

import './index.scss';

export default function Textarea(props) {
    const {content, disabled, field, isEditMode, onChange, onFocus, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    return (<>
        <TextField
          fullWidth
          error={Boolean(showErrorText)}
          helperText={showErrorText}
          multiline
          value={content[field.id] || ''}
          required={field.required}
          label={field.placeholder}
          variant="outlined"
          minRows={field?.options?.minRows || 4}
          maxRows={field?.options?.maxRows}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={isDisabled}
          inputProps={{maxLength: field?.options?.maxLength}}
        />

        {!showErrorText && (field?.details || field?.options?.maxLength) && <div className='fieldNotes'>
            {field?.options?.maxLength && <p>* максимальна кількість символів - {field?.options.maxLength}</p>}
            {field?.details && <p>{field.details}</p>}
        </div>}
    </>)
}
